import { Column, Index } from 'typeorm';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';

/**
 * The tenant's list of contact roles (Buyer, Accounts Payable, Decision-maker…),
 * editable per tenant (PD-17064, plan section 1 C2). Seeded with a general
 * distributor list; tenants whose contacts carry the older pharmacy contact
 * type codes also get those roles so nothing they used disappears.
 *
 * `titleKeywords` lets imported contact titles fill roles automatically: a
 * comma-separated list of normalized words or phrases ("ap,accounts payable,
 * payables"). The title itself is never changed.
 */
@Index('contact_role__name', ['name'], { unique: true })
@Entity('contact_role')
export class ContactRoleEntity extends BaseEntity {
	@Column('varchar', { name: 'name', length: 100 })
	public name!: string;

	@Column('varchar', { name: 'titleKeywords', length: 500, nullable: true })
	public titleKeywords!: string | null;

	/** The pharmacy-era `client_contact.type` code this role stands for, if any. */
	@Column('varchar', { name: 'legacyTypeCode', length: 16, nullable: true })
	public legacyTypeCode!: string | null;

	@Column('int', { name: 'sortOrder', default: () => "'0'" })
	public sortOrder!: number;

	@Column('tinyint', { name: 'isActive', width: 1, default: () => "'1'" })
	public isActive!: boolean;
}
